var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCutlery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m327.846 174.174h13.482v29.826h-29.507v79.87h90.014v-79.87h-30.507v-29.826h14.483c25.338 0 45.951-20.61 45.951-45.944v-128.23h-30v128.229c0 8.792-7.155 15.944-15.951 15.944h-14.483v-144.173h-30v144.174h-13.482c-8.796 0-15.952-7.152-15.952-15.944v-128.23h-30v128.229c0 25.334 20.614 45.945 45.952 45.945z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m401.835 467v-153.13h-90.014v153.13c0 24.813 20.187 45 45.014 45 24.813 0 45-20.187 45-45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m219.379 473.458c13.617-21.635 21.427-49.181 21.427-75.577 0-26.685-7.997-49.409-23.125-65.714-11.3-12.179-26.108-20.096-42.659-23.005v-31.076h30.507v-80.131h-90.014v80.131h29.507v31.258c-16.148 3.048-30.587 10.89-41.659 22.823-15.128 16.305-23.125 39.029-23.125 65.714 0 26.396 7.81 53.942 21.427 75.577 15.642 24.855 36.545 38.542 58.856 38.542s43.215-13.687 58.858-38.542z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.515 0c-24.813 0-45 20.187-45 45v122.956h90.014v-122.956c-.001-24.813-20.187-45-45.014-45z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCutlery);
export default __webpack_public_path__ + "static/media/cutlery.5f01aeefac9d0f465d31b4af334e5955.svg";
export { ForwardRef as ReactComponent };